import {
            AfterViewInit,
            ChangeDetectionStrategy,
            Component,
            ElementRef,
            Input,
            ViewChild,
            ViewEncapsulation
        } from '@angular/core';

import { CarouselService } from './carousel.service';
import { BrowserService } from '../../../shared/service/browser/browser.service';

@Component({
    selector: 'mlp-ng-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    // tslint:disable-next-line:use-view-encapsulation
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselSharedComponent implements AfterViewInit {

    @Input() config: string;
    @ViewChild('carouselOutterContainer') elContainer: ElementRef;
    @ViewChild('carouselPanel') el: ElementRef;
    lArrowDisabled = true;
    rArrowDisabled = true;

    constructor(private browserService: BrowserService, public carService: CarouselService) {}

    ngAfterViewInit(): void {
        if (this.browserService.isBrowser) {
            this.carService.setCarouselInitialConfig(this.el, this.elContainer);
            setTimeout(() => {
                this.carService.leftArrowDisabled$.subscribe(isDisabled => {
                    this.lArrowDisabled = isDisabled;
                });
                this.carService.rightArrowDisabled$.subscribe(isDisabled => {
                    this.rArrowDisabled = isDisabled;
                });
                this.carService.setArrows();
            }, 0);
        }
    }

    moveCarousel(direction: string): void {
        this.carService.moveCarousel(direction, this.lArrowDisabled, this.rArrowDisabled);
    }
}
